export default {
  doLoad () {
    this.$resource.get('/dashboard')
      .then((data) => {
        this.statistics = data
      })
  }
}



// WEBPACK FOOTER //
// ./src/app/dweller/dashboard/gadget/resources/methods.js